import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SkyddadRoute({ children }: { children: React.ReactNode }) {
  const { användare, laddar } = useAuth();

  if (laddar) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: '#888' }}>Laddar...</p>
    </div>
  );

  if (!användare) return <Navigate to="/login" replace />;

  return <>{children}</>;
}